import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityModule } from '@tc/security';
import { TranslateModule } from '@ngx-translate/core';
import { ContactDetailsCardComponent } from './contact-details-card.component';
import {MatTooltipModule} from '@angular/material';

@NgModule({
    imports: [
        TranslateModule.forChild(),
        CommonModule,
        SecurityModule,
        MatTooltipModule
    ],
    exports: [
        ContactDetailsCardComponent
    ],
    declarations: [
        ContactDetailsCardComponent
    ],
    providers: [],
})
export class ContactDetailsCardModule {
}
